import { useTranslation } from "react-i18next";
import { dictionaries } from "./config";
import { DEFAULT_LANG, isLang, type Dictionary, type Lang } from "./types";

/**
 * Returns the full structured dictionary for the active language.
 * Use this everywhere instead of i18next's string-only `t()` — the site copy is
 * deeply structured (arrays/objects) and this keeps it fully typed.
 */
export function useDict(): { dict: Dictionary; lang: Lang } {
  const { i18n } = useTranslation();
  const lang: Lang = isLang(i18n.language) ? i18n.language : DEFAULT_LANG;
  return { dict: dictionaries[lang], lang };
}
